module.exports = __webpack_public_path__ + "img/vplay-btn.76efb048.png";